import React, { useState } from "react";
import Button from "react-bootstrap/esm/Button";
import Image from "react-bootstrap/Image";
import Modal from "react-bootstrap/esm/Modal";

export default function DesignStepToolTip(props) {

    const [count, setCount] = useState(0);
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    let modalContent = null;

    let currentHelp = null;
    // console.log(props.designstep)
    // console.log(props.helps)
    props.helps.forEach(help => {
        if (props.designstep === help.help_step_id)
            currentHelp = help;
    });
    // console.log(currentHelp)
    if (currentHelp === null)
        modalContent = <></>
    else {
        modalContent =
            <>
                {currentHelp.help_gif_path !== null ? <Image width="100%" src={currentHelp.help_gif_path}></Image> : null}
                {currentHelp.help_text !== null ? <p>{currentHelp.help_text}</p> : null}
            </>
    }
    return (
        <>
            <Button onClick={handleShow}>?</Button>
            <Modal size="lg" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    {/* <Modal.Title>Help</Modal.Title> */}
                </Modal.Header>
                <Modal.Body>{modalContent}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Sluiten
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )

}